import type { ScreenSizeBreakpoints } from '@/types';

export const DEFAULT_SCREEN_SIZE_BREAKPOINTS: ScreenSizeBreakpoints = {
  break1: 1024,
  break2: 768,
  break3: 414,
  break4: 376,
  break5: 320,
};
